import * as React from 'react';
import { TextInput } from "@mantine/core";
import { IconSearch } from "@tabler/icons-react";
import { useDebouncedState } from "@mantine/hooks";
interface IProps {
    onChange: (value: string) => void;
    wait?: number;
}

const SearchInput = ({
    onChange,
    wait = 1
}: IProps) => {

    const [ searchValue, setSearchValue ] = useDebouncedState('', wait);

    React.useEffect(() => {
        onChange(searchValue);
    }, [searchValue]);

    return (
            <div style={{ width: 200, marginRight: 20 }}>
                <TextInput
                    autoComplete={'off'}
                    icon={<IconSearch size={18}/>}
                    placeholder={'Хайх...'}
                    onChange={e => setSearchValue(e.currentTarget.value)}
                />
            </div>
    )
};

export default SearchInput;